export default class CONST {
  static vehicleDonutOption = {
    chart: {
      width: 380,
      type: "donut",
    },
    legend: {
      show: false,
      position: "left",
    },
    labels: ["進場", "空位"],
    dataLabels: {
      enabled: false,
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: false,
              fontSize: '22px',
              fontFamily: 'Rubik',
              color: '#dfsda',
              offsetY: -10
            },
            value: {
              show: true,
              fontSize: '16px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              color: undefined,
              offsetY: 3,
              formatter: function (val) {
                return val
              }
            },
            total: {
              show: true,
              label: '',
              color: '#373d3f',
              formatter: function (w) {
                // return w.globals.seriesTotals.reduce((a, b) => {
                //   return  a + b
                // }, 0)
                return `${Math.round(w.globals.seriesTotals[0] / (w.globals.seriesTotals[0] + w.globals.seriesTotals[1]) * 100)} %`
              }
            }
          }
        }
      }
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
        },
      },
    ],
    colors: ["#4BBED8", "#91989b"],
  }

  static carCountOption = {
    chart: {
      height: 300,
      type: "line",
      toolbar: {
        show: false //hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "straight",
      dashArray: 0,
    },
    title: {
      text: "輛",
      align: "left",
    },
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return (
          val +
          " - " +
          opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
          ""
        );
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: [
        "0-2",
        "2-4",
        "4-6",
        "6-8",
        "8-10",
        "10-12",
        "12-14",
        "14-16",
        "16-18",
        "18-20",
        "20-22",
        "22-24",
      ],
    },
    tooltip: {
      y: [
        {
          title: {
            formatter: function (val) {
              return val + "(輛)";
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val + "(輛)";
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val + "(輛)";
            },
          },
        },
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  static peopleCountOption = {
    chart: {
      height: 300,
      type: "line",
      toolbar: {
        show: false //hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "straight",
      dashArray: 0,
    },
    title: {
      text: "位",
      align: "left",
    },
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return (
          val +
          " - " +
          opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
          ""
        );
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: [
        "0-2",
        "2-4",
        "4-6",
        "6-8",
        "8-10",
        "10-12",
        "12-14",
        "14-16",
        "16-18",
        "18-20",
        "20-22",
        "22-24",
      ],
    },
    tooltip: {
      y: [
        {
          title: {
            formatter: function (val) {
              return val + "(位)";
            },
          },
        }
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }
}